import { z } from 'src/lib'
import { getEndpoint } from '.'
import { BaseResponse } from 'src/types'
import { OperacionWRCFields } from '../types/fields'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

const schema = z.object({
    [OperacionWRCFields.CodSectorComercial]: z.number(),
    [OperacionWRCFields.NroComitente]: z.string(),
    [OperacionWRCFields.DenominacionComitente]: z.string(),
    [OperacionWRCFields.Observaciones]: z.string().optional(),
    [OperacionWRCFields.FechaEmision]: z.date().optional().nullable(),
    [OperacionWRCFields.FechaVencimiento]: z.date()
})

export type OperacionWRC_Update = z.infer<typeof schema>

export const put = (idOperacion: number, operacion: OperacionWRC_Update): Promise<BaseResponse> => {
    const endpoint = getEndpoint(`${idOperacion}`)

    const parsed = schema.safeParse(operacion)

    if (!parsed.success) {
        console.error('Error de validación:', parsed.error.issues)

        return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(endpoint, operacion) // TODO: parsed.data, no operacion
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
